import { Card, Col, Row, Button } from 'antd';
import './../assets/css/report.css'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { axiosConfig, ordinal_suffix_of, SERVER_PATH, valdateJson } from '../actions/common';
import PageHeader from './PageHeader';
import axios from 'axios';
import {useNavigate} from 'react-router-dom'

const Page = (props) => {
    const nav = useNavigate()
    const { 
        user, 
        report, 
        cas, 
        bas,  
        attendance,
        punctuality,
        subject, 
        studentid, 
        class_grades,
        rank_student, 
        rank_subject,
        rank_subjects,
        rank_students,
        student_pop, 
        data, 
        cahead,
        behavior 
    } = props

  
   
    
    let ca_sum = {}
    const store_data = localStorage.getItem('selectedresult') !== 'undefined' && localStorage.getItem('selectedresult') !== null && localStorage.getItem('selectedresult') !== undefined ? JSON.parse(localStorage.getItem('selectedresult')) : {}
    const reportinfo = store_data.data;
    const schoolinfo = store_data.schooldata;
    const claszinfo = store_data.classdata;
    const [fontz, setfontz] = useState(14)
    const [cadata, setcadata] = useState([])
    const [caunits, setcaunits] = useState([])
    const [caxs, setcaxs] = useState([])
    const [loadingData, setloadingData] = useState(false)
    const bgc = ['black', 'white']
 
    let {id:reportid} = reportinfo
    useEffect(() => {
        setloadingData(true)
        let params = {
            data:JSON.stringify({
                    'studentid':studentid,
                    'reportid':reportid,
            }),
            cat:'selected_caunit',
            table:'notes',
            narration:'get subjects'
        }
        axios.get(SERVER_PATH, {params}, axiosConfig)
        .then(res=>{
            let dt = res.data
            let d1 = dt[0]
            let d2 = dt[1]
            let d3 = dt[2]

            setcadata(d1)
            setcaxs(d3)
            setcaunits(d2)
            setloadingData(false)
        })
        .catch(err=>{setloadingData(false)})
    }, [])

    let caunit_arrays = caxs
    let claszparent = claszinfo.claszid
    //console.log(caunit_arrays)
    
    




    const sum1001 = (sumz, topscore)=>{
        if(sumz !== undefined && topscore !== undefined)
        {
            let score = sumz.reduce((a, b)=>parseFloat(a) + parseFloat(b), 0);
            let tscore = Object.values(topscore).filter(rw=>rw > 0).reduce((a,b)=>parseFloat(a) + parseFloat(b), 0);
            let mscore = (parseFloat(score)/tscore) * 100 
            return Number(mscore).toFixed(1)
        }
    }
    const sum1002 = (sumz, topscore, max)=>{
        if(sumz !== undefined && topscore !== undefined)
        {
            let score = sumz.reduce((a, b)=>parseFloat(a) + parseFloat(b), 0);
            let tscore = Object.values(topscore).filter(rw=>rw > 0).reduce((a,b)=>parseFloat(a) + parseFloat(b), 0);
            let mscore = (parseFloat(score)/tscore) * parseFloat(max) 
            return Number(mscore).toFixed(1)
        }
    }
    
    const avg = (sumz)=>{
        if(sumz !== undefined && Array.isArray(sumz) && sumz.length > 0)
        {
            let sums = sumz.reduce((a, b)=>parseFloat(a) + parseFloat(b), 0);
            return Number(sums/sumz.length).toFixed(1)}
    }  
  

    let subheader_store = {}
    if(Array.isArray(caunits)){
        caunits.forEach(element => {
            let {caid:id, subunit} = element || ''
            let rws = subunit && valdateJson(subunit) ? JSON.parse(subunit) : null
            //check if score setting is set
            if(rws == null || rws == ''){
                //if it is not use default
                if(subheader_store.hasOwnProperty(id)){
                    subheader_store[id].push(element)
                }else{
                    subheader_store[id] = []
                    subheader_store[id].push(element)
                }
            }else{
            //if it is set  create where to store class and subject settings
            let all_clasz_rows = {}
            //find all spcial settings for the class
            Object.keys(rws).forEach(rwid=>{
                //if found store in new object
                if(rws[rwid].claszid == claszparent){
                    all_clasz_rows[rwid] = rws[rwid]
                }
            });
            //check if any was stored in the new object
            
            if(Array.isArray(Object.keys(all_clasz_rows)) && Object.keys(all_clasz_rows).length > 0 ){
                //confirm if there is a special setting for this subject and class
                let main_row_key = Object.keys(all_clasz_rows)[0]
                let main_row_object = all_clasz_rows[main_row_key]
                element.maxscore = main_row_object?.score || 0
                console.log(main_row_object?.score, element)
                if(subheader_store.hasOwnProperty(id))
                {
                    subheader_store[id].push(element)
                }else{
                    subheader_store[id] = []
                    subheader_store[id].push(element)
                }

            }else{
                //if none was stored for this class then leave to the default
                if(subheader_store.hasOwnProperty(id))
                {
                    subheader_store[id].push(element)
                }else{
                    subheader_store[id] = []
                    subheader_store[id].push(element)
                }
            }
            }      
        });
    }

    let maindata = {}
    if(Array.isArray(cadata)){
        cadata.forEach(element => {
            let {id, itemid, itemid1, contact } = element
            if(maindata.hasOwnProperty(itemid)){
                if(maindata[itemid].hasOwnProperty(itemid1)){

                }else{
                    maindata[itemid][itemid1] = contact
                }
            }else{
                maindata[itemid] = {}
                maindata[itemid][itemid1] = contact
            }
        });
    }

    let s_sum = []
    let subject_sum = {}
    let subject_maxsum = {}
    let s_result = Object.keys(subject).sort((a,b)=>subject[a] > subject[b])
    let subject_result ={}
    
    s_result.forEach(key => { subject_result[key] = subject[key]; })
    Object.keys(subject_result).forEach(row=>{
        if(maindata && Array.isArray(Object.keys(maindata)) && maindata.hasOwnProperty(row)  && maindata[row] !== undefined )
          {
          if(subject_sum.hasOwnProperty(row)){}else{subject_sum[row] = [];}
          if(subject_maxsum.hasOwnProperty(row)){}else{subject_maxsum[row] = [];}
             caxs.filter(rw=>rw.typeid == 1).forEach(prp1=>{
                 let sh = []
                 let maxsh = []
                 if(subheader_store.hasOwnProperty(prp1.id)){
                        subheader_store[prp1.id].forEach(prp=>{
                            const {id, maxscore} = prp || ''
                            if(maindata && Array.isArray(Object.keys(maindata)) && maindata.hasOwnProperty(row) && maindata[row].hasOwnProperty(id))
                            {
                                sh.push(maindata[row][id] * maxscore)
                                maxsh.push(maxscore)
                               
                            }
                        })
                 }
             subject_sum[row].push(sum1002(sh, maxsh, prp1.maxscore))
             subject_maxsum[row].push(prp1.maxscore)
            })
         }
    })

    let num_subjects = 0
    let numbering = 0
    
    
    s_result.forEach(key => { subject_result[key] = subject[key]; })
    let acct = Object.keys(subject_result).map((row, ind)=>{
        if(maindata && Array.isArray(Object.keys(maindata)) && maindata.hasOwnProperty(row)  && maindata[row] !== undefined )
          {
          let subs= [];
          let adds = [];
          let ca_sums = {};
          num_subjects = num_subjects + 1;
          let d = subject_result !== undefined && subject_result.hasOwnProperty(row) && subject_result[row] !== null ? subject_result[row].split(":::") : [];
          return <tr key={`${row}`}  style={{fontSize: fontz+"px"}} >
          <td className="text-center m-0 p-0">
           {numbering = numbering + 1}
          </td>
          <td className="text-left m-0 p-0">
          <div style={{fontSize: fontz+"px", textTransform:'capitalize'}} className="m-0 p-0">{d[0]}</div>
          </td>
          {    
             caxs.filter(rw=>rw.typeid == 1).map(prp1=>{
                 let sh = []
                 let maxsh = []
                return <React.Fragment>
                    {subheader_store.hasOwnProperty(prp1.id) ?
                        subheader_store[prp1.id].map(prp=>{
                            const {id, abbrv, maxscore} = prp || ''
                            if(maindata && Array.isArray(Object.keys(maindata)) && maindata.hasOwnProperty(row) && maindata[row].hasOwnProperty(id))
                            {
                                sh.push(maindata[row][id] * maxscore)
                                maxsh.push(maxscore)
                                return <td 
                                    key={`${id}_${row}`} 
                                    className='text-center m-0 p-0' 
                                    style={{fontSize: fontz+"px"}} 
                                >
                                   {parseFloat(maindata[row][id]) > 0 ? Number(maindata[row][id] * maxscore).toFixed(1) : '-.-'}
                            </td>
                            }else{
                            return <td key={id} className="text-center" >
                                -0-
                            </td>
                            }
                        })
                    : null}
                    <th className="text-center" style={{backgroundColor:bgc[0], color:bgc[1], fontSize: fontz+"px"}} rowSpan={1}> {sum1002(sh, maxsh, prp1.maxscore )}</th>
                </React.Fragment>
            }) 
          }
          
          <th className='text-center m-0 p-0' style={{backgroundColor:bgc[0], color:bgc[1], fontSize: fontz+"px"}}>{sum1002(subject_sum[row], subject_maxsum[row], 100)}</th>
      </tr>
        }
    })
    
    
    
    //HEADER ROW 1
    let theadm = caxs.filter(rw=>rw.typeid == 1).map(prp=>{
        const {id, abbrv, maxscore} = prp || ''
        return <><th key={id} className="text-center" colSpan={subheader_store[id]?.length + 1 || 1}>
            {abbrv}
        </th>
        
        </>
    });
    
    let theadm1 = caxs.filter(rw=>rw.typeid == 1).map(prp1=>{
        return <>
            {subheader_store.hasOwnProperty(prp1.id) ?
                subheader_store[prp1.id].map(prp=>{
                    const {id, abbrv, maxscore} = prp || ''
                    return <th key={id} className="text-center" >
                        {abbrv}<br/>({maxscore ?? ''})
                    </th>
                })
            : null}
            <th className="text-center" rowSpan={1}>
            {prp1.maxscore}
        </th>
        </>
    });
    let tfootm = Object.keys(cas).map((prp, ind)=>{
        let d = avg(ca_sum[prp])
        return<th key={ind} className="text-center m-0 p-0 text-center align-self-center" width="60px">{d}</th>
    });

    
    const {
        surname,
        firstname,
        middlename,
        admission_no,
        admit,
        gender,
        abbrv,
        photo
    } = user || 'None';
    
    const {name:schoolname, staffname, officename, phone1 } = schoolinfo || ''
    const {name:claszname} = claszinfo || ''
    const {title:reportname} = reportinfo || ''
    let fullname = surname+" "+firstname+" "+middlename
    const move = () =>{
        nav(`./report/${reportid}/1`)
    }

    const movecbt = () =>{
        nav(`./reportcbt`)
    }
    
    return (
        <>
    <Row gap="small" wrap="wrap" className='no-print'>
    <Col style={{margin:'2px', padding:'5px'}}>
        <Button style={{padding:'3px', margin:'5px'}} onClick={()=>nav(-1)} type="info" shape="circle" className='mfe-2' icon={<i className="fa fa-backward"></i>} size='middle' />
        <Button style={{padding:'3px', margin:'5px'}}  onClick={()=>window.print()} type="primary" shape="circle" icon={<i className="fa fa-print"></i>} size='middle' />
        <Button style={{padding:'3px', margin:'5px'}}  onClick={()=>move(-1)} type="primary"  icon={<i className="fa fa-file"></i>} size='middle'>
        {" "}View Details
        </Button>
        <Button style={{padding:'3px', margin:'5px'}}  onClick={()=>movecbt(-1)} type="primary"  icon={<i className="fa fa-computer"></i>} size='middle'>
        {" "}CBT
        </Button>
        <Button  disabled={true} style={{padding:'3px', margin:'5px'}}   type="primary"  icon={<i className="fa fa-chat"></i>} size='middle'>
        {" "} Make Comments
        </Button>
    </Col>
    
    </Row>
        <div className="report container" id="maincont1" style={{margin:'auto', padding:'auto', backgroundColor:'#fff',}} >
        <div className="printpage" style={{marginLeft:'auto', marginRight:'auto'}}>
            <div className="A4" 
                style={{
                    overflow:'hidden',
                    position: 'relative',
                    backgroundColor:'#fff',
                    padding:'10px'
                }}>
            <Col>
                
                <span className="d-none d-print-block text-left p-10" >
                <PageHeader />
                <Row>
                    <Col span={24} className="reportname">
                        <h4>{reportname}</h4>
                    </Col>
                </Row>
                <Row>
                    <Col span={24} className="schoolname">
                        <h4>{schoolname}</h4>
                    </Col>
                </Row>
                </span>
                <Row>
                    <Col span={20}>
                    <Row span={24}>
                        <Col span={10} className='label_title' style={{textTransform:'capitalize'}}>Fullname </Col>
                        <Col span={14} className='text_title' style={{textTransform:'capitalize', fontWeight:'bold', fontSize:fontz+"px"}}>{fullname}</Col>
                    </Row>
                    <Row span={24}>
                        <Col span={10} className='label_title'>Matriculation Number</Col>
                        <Col span={14} className='text_title' style={{textTransform:'capitalize', fontWeight:'bold'}}>{abbrv}{admit}/{admission_no}</Col>
                    </Row>
                    <Row span={24}>
                        <Col span={10} className='label_title'>Gender</Col>
                        <Col span={14} className='text_title' style={{textTransform:'capitalize', fontWeight:'bold'}}>{gender}</Col>
                    </Row>
                    <Row span={24}>
                        <Col span={10} className='label_title'>Class</Col>
                        <Col span={14} className='text_title' style={{textTransform:'capitalize', fontWeight:'bold'}}>{claszname}</Col>
                    </Row>
                    <Row span={24}>
                        <Col span={10} className='label_title'>Dated</Col>
                        <Col span={14} className='text_title' style={{textTransform:'capitalize', fontWeight:'bold'}}>{new Date().toDateString()}</Col>
                    </Row>
                    </Col>
                <Col span={4} className="pull-left">
                <img 
                    width="120px" 
                    alt="photos"
                    height="120px" 
                    src={process.env.REACT_APP_SERVER_URL +"/"+ photo}
                    className="img img-responsive" 
                    style={{maxWidth:'120px'}} 
                    onError={(e)=>{e.target.onerror=null; e.target.src= process.env.PUBLIC_URL +'/asset/icons/profile_4.png'} }
                    />
            </Col>
                </Row>
                <hr/>
                <Row span={24} >  	
                <Col span={24} className='m-0 p-0'>
                <table  className="tabl" width="100%" border="3px solid #000" style={{fontFamily: 'Source Sans Pro', fontWeight:'bold'}}>
                    <thead>
                        <tr className="text-center justify-items-center align-items-center" style={{backgroundColor:bgc[0], color:bgc[1], fontSize:props.fontz+"px"}} >
                            <th rowSpan={2} className="text-center m-0 p-0">SN</th>
                            <th rowSpan={2} className="text-center m-0 p-0" style={{minWidth:'150px'}}>SUBJECT</th>
                            {theadm}
                            <th rowSpan={2} className="align-self-center text-center m-0 p-0">TOTAL<br/> (100%)</th>
                        </tr>
                        <tr className="text-center justify-items-center align-items-center" style={{backgroundColor:bgc[0], color:bgc[1], fontSize:props.fontz+"px"}} >
                            {theadm1}
                        </tr>
                    </thead>
                    <tbody style={{color:'#000'}}>
                    {acct}
                    </tbody>
                    {/* <tfoot>
                        <tr className="text-center" style={{backgroundColor:bgc[0], color:bgc[1], fontSize:props.fontz+"px"}}>
                            <th className="text-center m-0 p-0">SN</th>
                            <th className="text-center m-0 p-0">AVERAGE</th>
                            {tfootm}
                            <th className="text-center m-0 p-0">{avg(s_sum)}</th>
                            <th className="text-center m-0 p-0">{gradingf(avg(s_sum), class_grades)}<br/></th>
                        </tr>
                    </tfoot> */}
                </table>
            </Col>
        </Row>
            </Col>
            </div>
        </div>
        </div>
        </>
    )
}

const mapStateToProps = (state) => ({
    user : state.userReducer.user,
    school:state.schoolReducer.school
})

const mapDispatchToProps = {
    
}

export default connect(mapStateToProps, mapDispatchToProps)(Page)
